
import { clientPermissions } from "../../routes/routes_path";
import HttpClient from "../../utils/http";
import { userPermissions } from "../constants/api_endpoints";
import Session from "../../utils/session";

export function getUserPermissions() {
  const activeOrgId = Session.getActiveOrgId();
  return HttpClient.get(clientPermissions, {
    params: activeOrgId ? { orgId: activeOrgId } : undefined,
  });
}